import React from 'react';
import styles from '../../styles/Landlord/LandlordActivityFeed.module.css';

const LandlordActivityFeed = () => {
  return (
    <div className={styles.activityFeed}>
      <h3>Recent Activity</h3>
      <ul>
        <li>John Doe applied to Unit 202</li>
        <li>Maintenance requested for Unit 405</li>
        <li>Lease signed for Unit 303</li>
      </ul>
    </div>
  );
};

export default LandlordActivityFeed;
